import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useCollapsibleAlertStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            borderRadius: 16,
            border: '2px solid'
        },
        header: {
            gap: 8,
            fontSize: 22,
            width: '100%',
            cursor: 'pointer',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center'
        },
        title: {
            fontSize: 14,
            lineHeight: 1.4,
            fontWeight: 400,
            paddingRight: 24
        },
        collapsibleIcon: {
            fontSize: 14,
            marginLeft: 'auto'
        },

        content: {
            width: '100%',
            padding: '0px 44px 32px'
        },

        // Variants
        info: {
            'color': '#000000',
            'borderColor': '#BCB8AE',
            'backgroundColor': '#F8F5F1',

            '& .CollapsibleAlert__icon': {
                color: '#BAA997'
            }
        }
    })
);
